import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const dateRangeValid = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return value?.end && value?.start ? null : { dateRangeRequired: true };
  };
};
